// extracted by mini-css-extract-plugin
export default {"crosshairCursor":"canvas_crosshairCursor__xs0hk"};